import React, { useEffect, useState, useContext, useRef } from "react";

import TextField from "@material-ui/core/TextField";
import useSettings from "../../hooks/useSettings";
import { toast } from 'react-toastify';
import { makeStyles } from "@material-ui/core/styles";
import { grey, blue } from "@material-ui/core/colors";
import OnlyForSuperUser from "../OnlyForSuperUser";
import useAuth from "../../hooks/useAuth.js/index.js";

import {
  IconButton,
  InputAdornment,
} from "@material-ui/core";

import { Colorize, Delete } from "@material-ui/icons";
import ColorModeContext from "../../layout/themeContext";
import api from "../../services/api";
import { getBackendUrl } from "../../config";

import defaultLogoLight from "../../assets/logo.png";
import defaultLogoDark from "../../assets/logo-black.png";
import defaultLogoFavicon from "../../assets/favicon.ico";
import ColorBoxModal from "../ColorBoxModal/index.js";
import ThemeManager from "../LoginThemes/ThemeManager";
import LoginTheme from "../LoginThemes";
import { PaletteOutlined, ImageOutlined, DesktopWindowsOutlined, SmartphoneOutlined, InfoOutlined, CloudUploadOutlined } from "@material-ui/icons";
import "./whitelabelPremium.css";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: 240,
  },
  tab: {
    borderRadius: 4,
    width: "100%",
    "& .MuiTab-wrapper": {
      color: "#128c7e"
    },
    "& .MuiTabs-flexContainer": {
      justifyContent: "center"
    }


  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    marginBottom: 12,
    width: "100%",
  },
  cardAvatar: {
    fontSize: "55px",
    color: grey[500],
    backgroundColor: "#ffffff",
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: blue[700],
  },
  cardSubtitle: {
    color: grey[600],
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  colorAdorment: {
    width: 20,
    height: 20,
  },

  uploadInput: {
    display: "none",
  },

  appLogoLightPreviewDiv: {
    backgroundColor: "white",
    padding: "10px",
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "#424242",
    textAlign: "center",
  },

  appLogoDarkPreviewDiv: {
    backgroundColor: "#424242",
    padding: "10px",
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "white",
    textAlign: "center",
  },

  appLogoFaviconPreviewDiv: {
    padding: "10px",
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "black",
    textAlign: "center",
  },

  appLogoLightPreviewImg: {
    width: "100%",
    maxHeight: 72,
    content: "url(" + theme.calculatedLogoLight() + ")"
  },

  appLogoDarkPreviewImg: {
    width: "100%",
    maxHeight: 72,
    content: "url(" + theme.calculatedLogoDark() + ")"
  },

  appLogoFaviconPreviewImg: {
    width: "100%",
    maxHeight: 72,
    content: "url(" + ((theme.appLogoFavicon) ? theme.appLogoFavicon : "") + ")"
  }
}));

export default function Whitelabel(props) {
  const { settings } = props;
  const classes = useStyles();
  const [settingsLoaded, setSettingsLoaded] = useState({});

  const { getCurrentUserInfo } = useAuth();
  const [currentUser, setCurrentUser] = useState({});

  const { colorMode } = useContext(ColorModeContext);
  const [primaryColorLightModalOpen, setPrimaryColorLightModalOpen] = useState(false);
  const [primaryColorDarkModalOpen, setPrimaryColorDarkModalOpen] = useState(false);

  const logoLightInput = useRef(null);
  const logoDarkInput = useRef(null);
  const logoFaviconInput = useRef(null);
  const appNameInput = useRef(null);
  const [appName, setAppName] = useState(settingsLoaded.appName || "");
  const [previewTheme, setPreviewTheme] = useState("classic");
  const [publishedTheme, setPublishedTheme] = useState("classic");
  const [previewDevice, setPreviewDevice] = useState("desktop");

  const { update } = useSettings();

  function updateSettingsLoaded(key, value) {
    console.log("|=========== updateSettingsLoaded ==========|")
    console.log(key, value)
    console.log("|===========================================|")
    if (key === 'primaryColorLight' || key === 'primaryColorDark' || key === 'appName') {
      localStorage.setItem(key, value);
    };
    const newSettings = { ...settingsLoaded };
    newSettings[key] = value;
    setSettingsLoaded(newSettings);
  }

  useEffect(() => {
    getCurrentUserInfo().then(
      (u) => {
        setCurrentUser(u);
      }
    );

    if (Array.isArray(settings) && settings.length) {
      const primaryColorLight = settings.find((s) => s.key === "primaryColorLight")?.value;
      const primaryColorDark = settings.find((s) => s.key === "primaryColorDark")?.value;
      const appLogoLight = settings.find((s) => s.key === "appLogoLight")?.value;
      const appLogoDark = settings.find((s) => s.key === "appLogoDark")?.value;
      const appLogoFavicon = settings.find((s) => s.key === "appLogoFavicon")?.value;
      const appName = settings.find((s) => s.key === "appName")?.value;

      setAppName(appName || "");
      setSettingsLoaded({ ...settingsLoaded, primaryColorLight, primaryColorDark, appLogoLight, appLogoDark, appLogoFavicon, appName });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings]);

  async function handleSaveSetting(key, value) {

    await update({
      key,
      value,
    });
    updateSettingsLoaded(key, value);
    toast.success("Operação atualizada com sucesso.");
  }

  const uploadLogo = async (e, mode) => {
    if (!e.target.files) {
      return;
    }

    const file = e.target.files[0];
    const formData = new FormData();

    formData.append("typeArch", "logo");
    formData.append("mode", mode);
    formData.append("file", file);

    await api.post("/settings-whitelabel/logo", formData, {
      onUploadProgress: (event) => {
        let progress = Math.round(
          (event.loaded * 100) / event.total
        );
        console.log(
          `A imagem  está ${progress}% carregada... `
        );
      },
    }).then((response) => {
      updateSettingsLoaded(`appLogo${mode}`, response.data);
      colorMode[`setAppLogo${mode}`](getBackendUrl() + "/public/" + response.data);
    }).catch((err) => {
      console.error(
        `Houve um problema ao realizar o upload da imagem.`
      );
      console.log(err);
    });
  };

  const assetOptions = [
    {
      mode: "Light", title: "Logotipo claro", description: "Exibido sobre fundos claros.",
      input: logoLightInput, filename: settingsLoaded.appLogoLight,
      previewClass: classes.appLogoLightPreviewImg,
      previewSurface: "wl-preview-light", fallback: defaultLogoLight,
      setLogo: colorMode.setAppLogoLight
    },
    {
      mode: "Dark", title: "Logotipo escuro", description: "Exibido sobre fundos escuros.",
      input: logoDarkInput, filename: settingsLoaded.appLogoDark,
      previewClass: classes.appLogoDarkPreviewImg,
      previewSurface: "wl-preview-dark", fallback: defaultLogoDark,
      setLogo: colorMode.setAppLogoDark
    },
    {
      mode: "Favicon", title: "Favicon", description: "Ícone da guia do navegador.",
      input: logoFaviconInput, filename: settingsLoaded.appLogoFavicon,
      previewClass: classes.appLogoFaviconPreviewImg,
      previewSurface: "wl-preview-favicon", fallback: defaultLogoFavicon,
      setLogo: colorMode.setAppLogoFavicon
    }
  ];

  return (
    <OnlyForSuperUser user={currentUser} yes={() => (
      <div className="wl-premium">
        <div className="wl-editor-column">
          <section className="wl-panel" aria-label="Identidade visual">
            <header className="wl-panel-header">
              <span className="wl-section-icon"><PaletteOutlined /></span>
              <div><h2>Identidade visual</h2><p>Defina o nome e as cores principais da sua marca.</p></div>
            </header>
            <div className="wl-identity-fields">
              <div className="wl-field">
                <label htmlFor="appname-field">Nome do sistema</label>
                <TextField id="appname-field" variant="outlined" size="small" fullWidth
                  name="appName" value={appName} inputRef={appNameInput}
                  onChange={(e) => setAppName(e.target.value)}
                  onBlur={async (_) => {
                    await handleSaveSetting("appName", appName);
                    colorMode.setAppName(appName || "MarcoTicket");
                  }} />
              </div>
              <div className="wl-field">
                <label htmlFor="primary-color-light-field">Cor primária (modo claro)</label>
                <TextField id="primary-color-light-field" variant="outlined" size="small" fullWidth
                  value={settingsLoaded.primaryColorLight || ""}
                  onClick={() => setPrimaryColorLightModalOpen(true)}
                  InputProps={{
                    readOnly: true,
                    startAdornment: <InputAdornment position="start"><span className="wl-color-swatch" style={{ backgroundColor: settingsLoaded.primaryColorLight || "#2563eb" }} /></InputAdornment>,
                    endAdornment: <InputAdornment position="end"><IconButton size="small" aria-label="Selecionar cor clara" onClick={() => setPrimaryColorLightModalOpen(true)}><Colorize fontSize="small" /></IconButton></InputAdornment>
                  }} />
                <ColorBoxModal open={primaryColorLightModalOpen} handleClose={() => setPrimaryColorLightModalOpen(false)}
                  onChange={(color) => {
                    handleSaveSetting("primaryColorLight", `#${color.hex}`);
                    colorMode.setPrimaryColorLight(`#${color.hex}`);
                  }} currentColor={settingsLoaded.primaryColorLight} />
              </div>
              <div className="wl-field">
                <label htmlFor="primary-color-dark-field">Cor primária (modo escuro)</label>
                <TextField id="primary-color-dark-field" variant="outlined" size="small" fullWidth
                  value={settingsLoaded.primaryColorDark || ""}
                  onClick={() => setPrimaryColorDarkModalOpen(true)}
                  InputProps={{
                    readOnly: true,
                    startAdornment: <InputAdornment position="start"><span className="wl-color-swatch" style={{ backgroundColor: settingsLoaded.primaryColorDark || "#1e40af" }} /></InputAdornment>,
                    endAdornment: <InputAdornment position="end"><IconButton size="small" aria-label="Selecionar cor escura" onClick={() => setPrimaryColorDarkModalOpen(true)}><Colorize fontSize="small" /></IconButton></InputAdornment>
                  }} />
                <ColorBoxModal open={primaryColorDarkModalOpen} handleClose={() => setPrimaryColorDarkModalOpen(false)}
                  onChange={(color) => {
                    handleSaveSetting("primaryColorDark", `#${color.hex}`);
                    colorMode.setPrimaryColorDark(`#${color.hex}`);
                  }} currentColor={settingsLoaded.primaryColorDark} />
              </div>
            </div>
          </section>

          <section className="wl-panel" aria-label="Arquivos da marca">
            <header className="wl-panel-header">
              <span className="wl-section-icon"><ImageOutlined /></span>
              <div><h2>Arquivos da marca</h2><p>Visualize ou substitua os logos e o favicon já utilizados pelo sistema.</p></div>
            </header>
            <div className="wl-assets-grid">
              {assetOptions.map((asset) => (
                <div className="wl-asset-card" key={asset.mode}>
                  <div className="wl-asset-heading">
                    <strong>{asset.title}</strong>
                    {asset.filename && <IconButton size="small" title={`Remover ${asset.title.toLowerCase()}`} aria-label={`Remover ${asset.title.toLowerCase()}`}
                      onClick={() => {
                        handleSaveSetting(`appLogo${asset.mode}`, "");
                        asset.setLogo(asset.fallback);
                      }}><Delete fontSize="small" /></IconButton>}
                  </div>
                  <div className={`wl-asset-preview ${asset.previewSurface}`}>
                    <img alt={`Prévia: ${asset.title}`} className={asset.previewClass} />
                  </div>
                  <input type="file" id={`upload-logo-${asset.mode.toLowerCase()}-button`} ref={asset.input}
                    className={classes.uploadInput} onChange={(e) => uploadLogo(e, asset.mode)} />
                  <label htmlFor={`upload-logo-${asset.mode.toLowerCase()}-button`} className="wl-upload-action">
                    <CloudUploadOutlined fontSize="small" /> Substituir arquivo
                  </label>
                  <p className="wl-asset-description">{asset.description}</p>
                </div>
              ))}
            </div>
          </section>

          <ThemeManager externalPreview onSelectionChange={setPreviewTheme} onActiveChange={setPublishedTheme} />
        </div>

        <aside className="wl-preview-column" aria-label="Prévia da página de login">
          <div className="wl-preview-panel">
            <div className="wl-preview-heading">
              <div className="wl-preview-title"><DesktopWindowsOutlined /><div><h2>Prévia em tempo real</h2><p>Confira a aparência do tema antes de publicá-lo.</p></div></div>
              <span className="wl-current-theme">Tema publicado: {publishedTheme === "classic" ? "Original" : `Modelo ${publishedTheme}`}</span>
            </div>
            <div className="wl-device-switch" role="group" aria-label="Dispositivo da prévia">
              <button type="button" aria-pressed={previewDevice === "desktop"} className={previewDevice === "desktop" ? "is-current" : ""} onClick={() => setPreviewDevice("desktop")}><DesktopWindowsOutlined fontSize="small" /> Desktop</button>
              <button type="button" aria-pressed={previewDevice === "mobile"} className={previewDevice === "mobile" ? "is-current" : ""} onClick={() => setPreviewDevice("mobile")}><SmartphoneOutlined fontSize="small" /> Mobile</button>
            </div>
            <div className={`wl-live-preview ${previewDevice === "mobile" ? "wl-mobile-preview" : ""}`}>
              {previewTheme === "classic" ? (
                <div className="wl-original-preview"><span>Login original</span><h3>Prévia do tema padrão</h3><p>O login original será mantido quando você publicar essa opção.</p></div>
              ) : <LoginTheme themeId={previewTheme} preview />}
            </div>
            <div className="wl-preview-notice"><InfoOutlined fontSize="small" /><div>O tema selecionado é apenas uma prévia até clicar em <strong>Salvar tema de login</strong>. Cores, logos e nome continuam com o salvamento original do sistema.</div></div>
          </div>
        </aside>
      </div>
    )} />
  );
}
